// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const sektion = document.querySelector('.produkt-sida');
  if (!sektion) return;

  const galleri    = sektion.querySelector('[data-modal-galleri]');
  const modal      = sektion.querySelector('.produkt-sida__modal');
  const modalRam   = sektion.querySelector('.produkt-sida__modal-ram');
  const modalBild  = sektion.querySelector('.produkt-sida__modal-bild');
  const pdpIndex   = sektion.querySelector('[data-pdp-kortindex]');

  const reducerad  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const galleriBilder = galleri ? Array.from(galleri.querySelectorAll('.produkt-sida__bild')) : [];
  const totalBilder   = galleriBilder.length;
  const SKALA_MIN = 1;
  const SKALA_MAX = 2.5;

  const arMobil = () => window.matchMedia('(max-width: 900px)').matches;
  const scrollRorelse = () => (reducerad ? 'auto' : 'smooth');

  let aktivIndex = 0;
  let hjulLas = false;
  let hjulTimer = 0;

  const skrivIndex = (index) => {
    const i = Math.min(totalBilder - 1, Math.max(0, index));
    aktivIndex = i;
    if (pdpIndex) pdpIndex.textContent = `${i + 1} / ${totalBilder}`;
  };

  const indexFranScroll = () => {
    if (!galleri || totalBilder === 0) return 0;
    if (arMobil()) {
      return Math.round(galleri.scrollLeft / Math.max(1, galleri.clientWidth));
    }
    return Math.round(galleri.scrollTop / Math.max(1, galleri.clientHeight));
  };

  const scrollaTillBild = (index) => {
    if (!galleri || totalBilder === 0) return;
    const i = ((index % totalBilder) + totalBilder) % totalBilder;
    skrivIndex(i);
    const rorelse = scrollRorelse();
    if (arMobil()) {
      galleri.scrollTo({ left: i * galleri.clientWidth, top: 0, behavior: rorelse });
      return;
    }
    galleri.scrollTo({ top: i * galleri.clientHeight, left: 0, behavior: rorelse });
  };

  let galleriRorde = false;
  let galleriRordeTimer = 0;

  if (galleri) {
    galleri.addEventListener('scroll', () => {
      galleriRorde = true;
      window.clearTimeout(galleriRordeTimer);
      galleriRordeTimer = window.setTimeout(() => { galleriRorde = false; }, 160);
      skrivIndex(indexFranScroll());
    }, { passive: true });

    galleri.addEventListener('scrollend', () => {
      hjulLas = false;
    });

    galleri.addEventListener('wheel', (e) => {
      if (arMobil() || totalBilder < 2) return;
      if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      e.preventDefault();
      if (hjulLas) return;
      const riktning = e.deltaY > 0 ? 1 : -1;
      const nasta = aktivIndex + riktning;
      if (nasta < 0 || nasta >= totalBilder) return;
      hjulLas = true;
      window.clearTimeout(hjulTimer);
      hjulTimer = window.setTimeout(() => { hjulLas = false; }, reducerad ? 0 : 320);
      scrollaTillBild(nasta);
    }, { passive: false });
  }

  window.matchMedia('(max-width: 900px)').addEventListener('change', () => {
    requestAnimationFrame(() => { scrollaTillBild(aktivIndex); });
  });

  let modalAktivIndex = 0;
  let modalSkala = SKALA_MIN;
  let panX = 0;
  let panY = 0;
  let drag = null;
  let nypa = null;

  const aktuellSkala = () => modalSkala;

  const synkaSkala = () => {
    if (!modal) return;
    modal.style.setProperty('--modal-skala', String(modalSkala));
    modal.dataset.skala = modalSkala <= SKALA_MIN + 0.01 ? '1' : '2';
    const inn = modal.querySelector('[data-action="modal/in"]');
    const ut = modal.querySelector('[data-action="modal/ut"]');
    if (inn) inn.disabled = modalSkala >= SKALA_MAX - 0.01;
    if (ut) ut.disabled = modalSkala <= SKALA_MIN + 0.01;
  };

  const skrivPan = () => {
    if (!modal) return;
    modal.style.setProperty('--modal-x', `${panX}px`);
    modal.style.setProperty('--modal-y', `${panY}px`);
  };

  const klampPan = () => {
    if (!modal || !modalRam || !modalBild) {
      skrivPan();
      return;
    }
    const s = aktuellSkala();
    const maxX = Math.max(0, (modalBild.offsetWidth * s - modalRam.clientWidth) / 2);
    const maxY = Math.max(0, (modalBild.offsetHeight * s - modalRam.clientHeight) / 2);
    panX = Math.min(maxX, Math.max(-maxX, panX));
    panY = Math.min(maxY, Math.max(-maxY, panY));
    skrivPan();
  };

  const nollstallPan = () => {
    panX = 0;
    panY = 0;
    drag = null;
    if (modal) modal.dataset.pan = '';
    skrivPan();
  };

  const klampaSkala = (v) => Math.min(SKALA_MAX, Math.max(SKALA_MIN, v));

  const sattSkala = (nu, clientX, clientY) => {
    const forra = modalSkala;
    modalSkala = klampaSkala(nu);
    synkaSkala();
    if (modalSkala <= SKALA_MIN + 0.01) {
      nollstallPan();
      return;
    }
    if (clientX != null && clientY != null && modalRam && forra > 0) {
      const box = modalRam.getBoundingClientRect();
      const px = clientX - box.left - box.width / 2;
      const py = clientY - box.top - box.height / 2;
      const kvot = modalSkala / forra;
      panX = px * (1 - kvot) + panX * kvot;
      panY = py * (1 - kvot) + panY * kvot;
    }
    klampPan();
  };

  const zoomaMot = (steg, clientX, clientY) => {
    const nivaer = [1, 1.5, 2, 2.5];
    let i = 0;
    nivaer.forEach((n, idx) => {
      if (modalSkala + 0.01 >= n) i = idx;
    });
    sattSkala(nivaer[Math.min(nivaer.length - 1, Math.max(0, i + Math.sign(steg)))], clientX, clientY);
  };

  const zooma = (steg) => {
    zoomaMot(steg);
  };

  const oppnaModal = (index) => {
    if (!modal || totalBilder === 0) return;
    const i = ((index % totalBilder) + totalBilder) % totalBilder;
    modalAktivIndex = i;
    const lank = galleriBilder[i];
    if (!lank) return;
    modalBild.src = lank.href;
    modalBild.alt = lank.getAttribute('aria-label') || '';
    const tumme = lank.querySelector('img');
    if (tumme) {
      if (tumme.naturalWidth) modalBild.width = tumme.naturalWidth;
      if (tumme.naturalHeight) modalBild.height = tumme.naturalHeight;
    }
    modalSkala = SKALA_MIN;
    synkaSkala();
    nollstallPan();
    modal.removeAttribute('hidden');
    requestAnimationFrame(() => { modal.dataset.state = 'oppen'; });
    modal.focus({ preventScroll: true });
  };

  const stangModal = () => {
    if (!modal || modal.dataset.state !== 'oppen') return;
    modal.dataset.state = 'stangd';
    nollstallPan();
    const dolj = () => {
      modal.setAttribute('hidden', '');
    };
    if (reducerad) {
      dolj();
      return;
    }
    modal.addEventListener('transitionend', (e) => {
      if (e.propertyName && e.propertyName !== 'opacity') return;
      dolj();
    }, { once: true });
  };

  const modalNavigera = (riktning) => {
    oppnaModal(modalAktivIndex + riktning);
  };

  if (modalRam) {
    const startaPan = (id, x, y) => {
      if (!modal || modal.dataset.state !== 'oppen' || modalSkala <= SKALA_MIN + 0.01) return false;
      modal.dataset.pan = 'ja';
      drag = { id, x, y, ox: panX, oy: panY };
      return true;
    };

    const flyttaPanXY = (id, x, y) => {
      if (!drag || drag.id !== id) return;
      panX = drag.ox + (x - drag.x);
      panY = drag.oy + (y - drag.y);
      klampPan();
    };

    const slutaPan = (id) => {
      if (!drag || (id != null && drag.id !== id)) return;
      drag = null;
      if (modal) modal.dataset.pan = '';
    };

    modalRam.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return;
      if (e.button != null && e.button !== 0) return;
      if (!startaPan(e.pointerId, e.clientX, e.clientY)) return;
      e.preventDefault();
      try { modalRam.setPointerCapture(e.pointerId); } catch (_) {}
    });

    const flyttaPekare = (e) => {
      if (e.pointerType === 'touch') return;
      flyttaPanXY(e.pointerId, e.clientX, e.clientY);
    };

    modalRam.addEventListener('pointermove', flyttaPekare);
    document.addEventListener('pointermove', flyttaPekare);
    modalRam.addEventListener('pointerup', (e) => slutaPan(e.pointerId));
    modalRam.addEventListener('pointercancel', (e) => slutaPan(e.pointerId));
    document.addEventListener('pointerup', (e) => slutaPan(e.pointerId));

    const nypaAvstand = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    const nypaMitt = (a, b) => ({
      x: (a.clientX + b.clientX) / 2,
      y: (a.clientY + b.clientY) / 2,
    });

    modalRam.addEventListener('touchstart', (e) => {
      if (e.touches.length >= 2) {
        slutaPan('touch');
        const a = e.touches[0];
        const b = e.touches[1];
        nypa = { d: Math.max(1, nypaAvstand(a, b)), s: modalSkala };
        if (modal) modal.dataset.pan = 'ja';
        e.preventDefault();
        return;
      }
      if (nypa || e.touches.length !== 1) return;
      if (!startaPan('touch', e.touches[0].clientX, e.touches[0].clientY)) return;
      e.preventDefault();
    }, { passive: false });

    modalRam.addEventListener('touchmove', (e) => {
      if (e.touches.length >= 2) {
        const a = e.touches[0];
        const b = e.touches[1];
        if (!nypa) nypa = { d: Math.max(1, nypaAvstand(a, b)), s: modalSkala };
        const mitt = nypaMitt(a, b);
        sattSkala(nypa.s * (nypaAvstand(a, b) / nypa.d), mitt.x, mitt.y);
        e.preventDefault();
        return;
      }
      if (!drag || drag.id !== 'touch' || e.touches.length !== 1) return;
      e.preventDefault();
      flyttaPanXY('touch', e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: false });

    modalRam.addEventListener('touchend', (e) => {
      if (e.touches.length < 2) nypa = null;
      if (e.touches.length === 0) slutaPan('touch');
    });
    modalRam.addEventListener('touchcancel', () => {
      nypa = null;
      slutaPan('touch');
    });

    modalRam.addEventListener('wheel', (e) => {
      if (!modal || modal.dataset.state !== 'oppen') return;
      e.preventDefault();
      if (e.ctrlKey || e.metaKey) {
        sattSkala(modalSkala * Math.exp(-e.deltaY * 0.01), e.clientX, e.clientY);
        return;
      }
      zoomaMot(e.deltaY < 0 ? 1 : -1, e.clientX, e.clientY);
    }, { passive: false });
  }

  if (modalBild) {
    modalBild.addEventListener('load', () => { klampPan(); });
  }

  document.addEventListener('click', (e) => {
    const bildlank = e.target.closest('[data-action~="galleri/modal"]');
    if (bildlank && sektion.contains(bildlank)) {
      e.preventDefault();
      if (galleriRorde) return;
      const index = parseInt(bildlank.dataset.galleriIndex || '0', 10);
      oppnaModal(index);
      return;
    }

    if (modal && modal.dataset.state === 'oppen' && e.target === modal) {
      stangModal();
      return;
    }

    const action = e.target.closest('[data-action]')?.dataset.action;

    if (action === 'modal/stang') { stangModal(); return; }
    if (action === 'modal/nasta') { modalNavigera(1); return; }
    if (action === 'modal/fore')  { modalNavigera(-1); return; }
    if (action === 'modal/in')    { zooma(1); return; }
    if (action === 'modal/ut')    { zooma(-1); return; }

    if (action === 'kortbild/fore' && sektion.contains(e.target)) {
      scrollaTillBild(aktivIndex - 1);
      return;
    }
    if (action === 'kortbild/nasta' && sektion.contains(e.target)) {
      scrollaTillBild(aktivIndex + 1);
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!modal || modal.dataset.state !== 'oppen') return;
    if (e.key === 'Escape')     stangModal();
    if (e.key === 'ArrowLeft')  modalNavigera(-1);
    if (e.key === 'ArrowRight') modalNavigera(1);
  });

  const info = sektion.querySelector('.produkt-sida__info');
  const form = sektion.querySelector('.produkt-sida__form');
  const varianterJson = sektion.querySelector('[data-produkt-varianter]');
  const tillstand = { tillganglig: 'tillganglig', slutsald: 'slutsald', ogiltig: 'ogiltig' };
  let uppdateraVariant = null;

  if (form && varianterJson && info) {
    let alternativ = [];
    let varianter = [];
    try {
      const data = JSON.parse(varianterJson.textContent);
      alternativ = (data.alternativ ?? []).filter(Boolean);
      varianter = data.varianter ?? [];
    } catch (_) { alternativ = []; varianter = []; }

    if (varianter.length && alternativ.length) {
      const idInput = form.querySelector('[name="id"]');
      const prisEl = sektion.querySelector('.produkt-sida__pris');
      const jamforprisEl = sektion.querySelector('.produkt-sida__jamforpris');
      const knapp = form.querySelector('[data-action~="varukorg/lagg-till"]');

      const hamtaValdaAlternativ = () => alternativ.map((n) => form.querySelector(`input[name="${CSS.escape(n)}"]:checked`)?.value ?? null);

      const matcharDelvis = (variant, valda, index, varde) => variant.options.every((opt, i) => {
        const v = i === index ? varde : valda[i];
        return v == null || opt === v;
      });

      const finnsKombination = (valda, index, varde) => varianter.some((v) => matcharDelvis(v, valda, index, varde));

      const hittaVariant = (valda) => {
        if (valda.some((v) => v == null)) return null;
        return varianter.find((v) => v.options.every((opt, i) => opt === valda[i])) ?? null;
      };

      const uppdateraTillganglighet = (valda) => {
        form.querySelectorAll('.produkt-sida__alternativ-radio').forEach((radio) => {
          const index = alternativ.indexOf(radio.name);
          const label = radio.closest('.produkt-sida__alternativ-val');
          const ok = index === -1 ? true : finnsKombination(valda, index, radio.value);
          radio.disabled = !ok;
          if (label) label.dataset.tillstand = ok ? '' : 'ogiltig';
        });
      };

      const repareraVal = () => {
        let fix = false;
        alternativ.forEach((namn) => {
          const checked = form.querySelector(`input[name="${CSS.escape(namn)}"]:checked`);
          if (checked && !checked.disabled) return;
          const fallback = form.querySelector(`input[name="${CSS.escape(namn)}"]:not(:disabled)`);
          if (fallback && fallback !== checked) {
            fallback.checked = true;
            fix = true;
          }
        });
        return fix;
      };

      const sattTillstand = (nytt) => {
        info.dataset.tillstand = nytt;
        if (knapp) {
          knapp.disabled = nytt !== tillstand.tillganglig;
          knapp.setAttribute('aria-disabled', nytt === tillstand.tillganglig ? 'false' : 'true');
        }
      };

      uppdateraVariant = () => {
        let valda = hamtaValdaAlternativ();
        uppdateraTillganglighet(valda);
        if (repareraVal()) {
          valda = hamtaValdaAlternativ();
          uppdateraTillganglighet(valda);
        }
        const variant = hittaVariant(valda);
        if (!variant) {
          info.dataset.valdVariantId = '';
          info.dataset.jamforpris = 'dold';
          if (idInput) idInput.value = '';
          sattTillstand(tillstand.ogiltig);
          return null;
        }
        info.dataset.valdVariantId = String(variant.id);
        info.dataset.jamforpris = variant.compare_at_price > variant.price ? 'visas' : 'dold';
        if (idInput) idInput.value = String(variant.id);
        if (prisEl) prisEl.textContent = variant.price_formatted;
        if (jamforprisEl) jamforprisEl.textContent = variant.compare_at_price_formatted;
        sattTillstand(variant.available ? tillstand.tillganglig : tillstand.slutsald);
        return variant;
      };

      form.synkaValdVariant = uppdateraVariant;
      form.addEventListener('submit', () => { uppdateraVariant(); }, true);
      uppdateraVariant();
    }
  }

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('.produkt-sida__alternativ-radio');
    if (!radio || !sektion.contains(radio)) return;
    const variant = uppdateraVariant?.();
    const index = variant?.featured_image_index ?? radio.dataset.variantBildIndex;
    if (index != null && index !== '') scrollaTillBild(Number(index));
  });
})();
